import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import React, { useState, useEffect, useContext } from 'react';
import Loadable from '@loadable/component';
import { useTheme } from 'emotion-theming';
import { isBrowser, isPastScrollYMark } from '@jelly/utils';
import { EmailSubscribeContext } from '../EmailSubscribeProvider';
var THRESHOLD = 0.2;

var dontShowEmailCapture = function dontShowEmailCapture(isVisible) {
  return (!isBrowser() || sessionStorage.getItem('closedEmailModal')) && !isVisible;
};

var LazyEmailSignUpFloaterBar = Loadable(function () {
  return import(
  /* webpackChunkName: 'EmailSignup' */
  './LazyEmailSignUpFloaterBar').then(function (_ref) {
    var LazyEmailSignUpFloaterBar = _ref.LazyEmailSignUpFloaterBar,
        _ref$mobile = _ref.mobile,
        mobile = _ref$mobile === void 0 ? true : _ref$mobile;
    return LazyEmailSignUpFloaterBar;
  });
});
export var EmailSignUpFloaterBar = function EmailSignUpFloaterBar(_ref2) {
  var source = _ref2.source;

  var _useTheme = useTheme(),
      MATCH_MEDIA = _useTheme.MATCH_MEDIA;

  var isWeb = isBrowser() && window.matchMedia(MATCH_MEDIA.M).matches;

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      isPastY = _useState2[0],
      setScrollY = _useState2[1];

  var _useState3 = useState(false),
      _useState4 = _slicedToArray(_useState3, 2),
      wasFormTriggered = _useState4[0],
      setWasFormTriggered = _useState4[1];

  var _useState5 = useState(isWeb ? 'pulledUp' : 'peeking'),
      _useState6 = _slicedToArray(_useState5, 2),
      modalView = _useState6[0],
      setModalView = _useState6[1];

  var _useContext = useContext(EmailSubscribeContext),
      isVisible = _useContext.isVisible,
      setIsVisible = _useContext.setIsVisible,
      isScrollListenerEnabled = _useContext.isScrollListenerEnabled;

  useEffect(function () {
    setWasFormTriggered(isVisible);

    if (isVisible) {
      setModalView('pulledUp');
    }
  }, [isVisible]); // monitor the user's scrolling. Once the Y-threshold is passed, trigger the form

  useEffect(function () {
    var unsubscribeCallback;

    if (isScrollListenerEnabled) {
      // start observing scroll position relative to threshold
      unsubscribeCallback = isPastScrollYMark(THRESHOLD, setScrollY); // if we are past the threshold let's trigger

      if (isPastY && !wasFormTriggered) {
        setWasFormTriggered(true);
      }
    }

    return function () {
      unsubscribeCallback && unsubscribeCallback();
    };
  }, [wasFormTriggered, isPastY, setIsVisible, isScrollListenerEnabled]);

  if (dontShowEmailCapture(isVisible)) {
    return null;
  }

  var handleViewChange = function handleViewChange() {
    var view = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'closed';
    setModalView(view);

    if (view === 'closed') {
      sessionStorage.setItem('closedEmailModal', true);
      setIsVisible(false);
    }
  };

  if (wasFormTriggered) {
    return /*#__PURE__*/React.createElement(LazyEmailSignUpFloaterBar, {
      isMobileView: !isWeb,
      handleViewChange: handleViewChange,
      modalView: modalView,
      source: source,
      wasFormTriggered: wasFormTriggered
    });
  }

  return null;
};